module.exports = __webpack_public_path__ + "695b3d379c5c147047b3cad6ffe68ef9.svg";